import { ArrowRightIcon } from '@heroicons/react/24/outline'
import { Link } from 'libs/router'
import { useTranslation } from 'libs/i18n'

type DashboardViewAllLinkProps = {
	to: string
}

export const DashboardViewAllLink = ({ to }: DashboardViewAllLinkProps) => {
	const { t } = useTranslation()

	return (
		<div className="border-t border-border p-3">
			<Link
				to={to}
				className="flex h-9 w-full items-center justify-center gap-1.5 rounded-md border border-border bg-background text-[12px] font-medium text-foreground shadow transition-colors hover:bg-muted">
				{t('View all')}
				<ArrowRightIcon className="h-3.5 w-3.5 stroke-2" />
			</Link>
		</div>
	)
}
